(ns admin.components.composite.resource-library
  (:require
   [applied-science.js-interop :as j]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]
   [kyber.components.base.text :as text]
   [kyber.components.base.button :as button]
   [kyber.components.composite.loading :as loading]
   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.containers.not-found :as not-found]
   [kyber.lib.kyber-db :as kyber-db]
   [kyber.utils :as ku]
   [admin.styles.constants :as sc]
   [admin.components.forms.resource-metadata :as resource-metadata-form]
   [admin.components.composite.resource-selector :as resource-selector]
   [admin.components.composite.resource-uploader :as resource-uploader]
   [admin.subscriptions.activity-resources :as <activity-resources]
   [admin.events.activity-resources :as >activity-resources]))

(def classes
  (styles->classes
   {:resource-list
    {:background-color (gs [:colors :true-white])
     :padding (gs [:spacing :p20])
     :margin [(gs [:spacing :p0]) :auto
              (gs [:spacing :p40]) :auto]
     :max-width sc/max-resource-library-width}

    :resource-form-container
    {:background-color (gs [:colors :true-white])
     :padding (gs [:spacing :p20])
     :margin [(gs [:spacing :p40]) :auto]
     :max-width sc/max-resource-form-width}

    :page-title
    {:margin [(gs [:spacing :p0]) :auto
              (gs [:spacing :p20]) :auto]
     :text-align :center}

    :new-resource-container
    {:padding (gs [:spacing :p20])
     :background-color (gs [:colors :true-white])
     :max-width sc/max-resource-library-width
     :margin [(gs [:spacing :p0])
              :auto
              (gs [:spacing :p40])
              :auto]}}))

(defn- render-resource-list
  [{:keys [resources editing-resource learning-objectives]}]
  [:div {:class (:resource-list classes)}
   [text/title-40 :p
    {:class (:page-title classes)}
    "Search Resource Library"]
   [resource-selector/render
    {:on-select #(reset! editing-resource %)
     :learning-objectives learning-objectives
     :resources resources
     :per-page 15
     :cta-copy "Edit"}]])

(defn- render-select-a-resource
  [{:keys [adding-new-resource
           learning-objectives
           activity-uuid
           available-resources]}]
  [:div {:class (:resource-list classes)}
   [text/title-40 :p
    {:class (:page-title classes)}
    "Select a Resource"]

   [resource-selector/render
    {:on-select #(do
                   (reset! adding-new-resource false)
                   (re-frame/dispatch
                    [::>activity-resources/link-activity-resource
                     {:activity/uuid activity-uuid
                      :resource/uuid (:resource/uuid %)}
                     {:response-keys
                      (into (kyber-db/get-model-keys :resource)
                            [:activity/uuid
                             {:resource/learning-objective
                              [:learning-objective/uuid
                               :learning-objective/label
                               :learning-objective/description]}])}]))

     :learning-objectives learning-objectives
     :resources available-resources
     :per-page 15
     :cta-copy "Add"
     :activity-uuid activity-uuid}]

   [button/secondary-button
    {:style {:margin-top (gs [:spacing :p20])}
     :on-click #(reset! adding-new-resource false)}
    "Back to activity resources"]])

(defn- generate-failure-message [{:keys [response]}]
  (if-let [reason (get-in response ['activity/unlink-resource :com.wsscode.pathom3.connect.runner/mutation-error])]
    (j/get reason :message)
    "Failed to remove resource"))

(defn- render-editing-resource
  [{:keys [editing-resource
           activity-uuid
           curriculum-uuid
           learning-objectives]}]
  (let [cancel #(reset! editing-resource nil)]
    [:div {:class (:resource-form-container classes)}
     [text/title-40 :p
      {:class (:page-title classes)}
      "Edit Resource"]

     [resource-metadata-form/render
      {:on-cancel cancel
       :learning-objectives learning-objectives
       :activity-uuid activity-uuid
       :curriculum-uuid curriculum-uuid
       :on-resource-removed #(do
                               (cancel)
                               (re-frame/dispatch
                                [::>activity-resources/unlink-activity-resource
                                 {:activity/uuid activity-uuid
                                  :resource/uuid (:resource/uuid %)}
                                 {:on-failure-toast generate-failure-message
                                  :on-success-toast "Resource deleted"}]))}
      @editing-resource]]))

(defn render-activity-resource-library
  [{:keys [params]}]
  (let [{:keys [curriculum-uuid activity-uuid]} params
        activity
        (re-frame/subscribe
         [::kyber-db/get-record
          {:model :activity
           :ident activity-uuid}])

        editing-resource (reagent/atom nil)
        adding-new-resource (reagent/atom false)

        available-activity-resources
        (re-frame/subscribe [::<activity-resources/available params])]
    (fn []
      (let [{learning-objectives :activity/learning-objectives
             activity-resources :activity/resources}
            @activity]
        (if (some? @activity)
          [:div
           (cond
             (some? @editing-resource)
             [render-editing-resource
              {:learning-objectives learning-objectives
               :curriculum-uuid curriculum-uuid
               :activity-uuid activity-uuid
               :editing-resource editing-resource}]

             (true? @adding-new-resource)
             [render-select-a-resource
              {:adding-new-resource adding-new-resource
               :learning-objectives learning-objectives
               :available-resources @available-activity-resources
               :activity-uuid activity-uuid
               :curriculum-uuid curriculum-uuid}]

             :else
             [:<>
              [render-resource-list
               {:resources activity-resources
                :editing-resource editing-resource
                :learning-objectives learning-objectives}]
              [:div {:class (:new-resource-container classes)}
               [text/title-40 :p
                {:class (:page-title classes)}
                "Add a new resource"]

               [text/title-20 :p
                {:style {:text-align :center}}
                "Select a resource from another activity"]

               [:div {:style {:padding (gs [:spacing :p20])
                              :display :flex
                              :justify-content :center}}
                [button/primary-button
                 {:on-click #(reset! adding-new-resource true)}
                 "Add an Existing Resource"]]

               [text/title-20 :p
                {:style {:text-align :center}}
                "Or, upload a new resource"]

               [resource-uploader/render
                {:curriculum-uuid curriculum-uuid
                 :activity-uuid activity-uuid}]]])]
          [not-found/not-found])))))

(defn render
  [{:keys [resource-status] :as ctx}]
  (if (ku/all-resources-loaded? resource-status)
    [render-activity-resource-library ctx]
    [loading/render
     {:loading-message "Please wait while we fetch your resources"}]))
